module.exports = __webpack_public_path__ + "static/media/calendar.96623d51.svg";